import {AfterViewInit, Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: '[currencyParser]',
  standalone: true
})
export class CurrencyParserDirective {

  constructor(private el: ElementRef) { }

  ngAfterViewInit(){
    this.formatCurrentValue()
  }

  @HostListener('blur') onBlur() {
    let value: number = parseFloat(this.el.nativeElement.value.replace(/,/g, ''));
    if (!isNaN(value)) {
      this.el.nativeElement.value = value.toLocaleString(

        undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }

      ); // Formats with local-specific thousands separators
    }
  }

  @HostListener('focus') onFocus() {
    // Optional: Remove commas when the user focuses the input for easier editing
    let value = this.el.nativeElement.value;
    this.el.nativeElement.value = value.replace(/,/g, '');
  }
  private formatCurrentValue() {
    const raw = (this.el.nativeElement.value ?? '').toString();
    const num = parseFloat(raw.replace(/,/g, ''));
    if (!isNaN(num)) {
      this.el.nativeElement.value = num.toLocaleString(

        undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }

      );
    }
  }


}
